export type AsmaCategory =
  | "rehmat"
  | "qudrat"
  | "ilm"
  | "rizq"
  | "adal"
  | "hifazat"
  | "khalq"
  | "zindagi"
  | "azmat";

export interface AsmaName {
  id: number;
  arabic: string;
  transliteration: string;
  meaning: string;
  reflection: string;
  benefit: string;
  memoryTip?: string; // optional
  category: AsmaCategory;
}

export const asma: AsmaName[] = [
  {
    id: 1,
    arabic: "ٱلرَّحْمَٰنُ",
    transliteration: "Ar-Rahman",
    meaning: "Be-had reham karne wala",
    reflection: "Allah ki rehmat har makhlooq ko gheray hue hai.",
    benefit: "Ya Rahman parhne se dil mein narmi aur rehmat paida hoti hai.",
    category: "rehmat",
  },
  {
    id: 2,
    arabic: "ٱلرَّحِيمُ",
    transliteration: "Ar-Raheem",
    meaning: "Nihayat meherban",
    reflection: "Woh apne momino par khaas reham farmata hai.",
    benefit: "Ya Raheem mushkil waqt mein tasalli deta hai.",
    category: "rehmat",
  },
  {
    id: 3,
    arabic: "ٱلْمَلِكُ",
    transliteration: "Al-Malik",
    meaning: "Haqeeqi badshah",
    reflection: "Asli hukumat sirf Allah ki hai.",
    benefit: "Ya Malik parhne se izzat aur quwwat naseeb hoti hai.",
    category: "qudrat",
  },
  {
    id: 4,
    arabic: "ٱلْقُدُّوسُ",
    transliteration: "Al-Quddus",
    meaning: "Har aib se paak",
    reflection: "Allah har kami aur nuqs se bilkul paak hai.",
    benefit: "Ya Quddus parhne se roohani safai milti hai.",
    category: "azmat",
  },
  {
    id: 5,
    arabic: "ٱلسَّلَامُ",
    transliteration: "As-Salaam",
    meaning: "Salamti dene wala",
    reflection: "Asal aman aur sukoon Allah se milta hai.",
    benefit: "Ya Salaam parhne se bechaini kam hoti hai.",
    category: "hifazat",
  },
  {
    id: 6,
    arabic: "ٱلْمُؤْمِنُ",
    transliteration: "Al-Mu’min",
    meaning: "Aman dene wala",
    reflection: "Woh apne bandon ko mehfooz rakhta hai.",
    benefit: "Ya Mu’min khauf aur darr ko kam karta hai.",
    category: "hifazat",
  },
  {
    id: 7,
    arabic: "ٱلْمُهَيْمِنُ",
    transliteration: "Al-Muhaymin",
    meaning: "Nigrani karne wala",
    reflection: "Har cheez uski nigrani mein hai.",
    benefit: "Ya Muhaymin parhne se hifazat ka ehsaas hota hai.",
    category: "hifazat",
  },
  {
    id: 8,
    arabic: "ٱلْعَزِيزُ",
    transliteration: "Al-Aziz",
    meaning: "Zabardast quwwat wala",
    reflection: "Koi bhi Allah par ghalib nahi aa sakta.",
    benefit: "Ya Aziz parhne se izzat aur taqat milti hai.",
    category: "qudrat",
  },
  {
    id: 9,
    arabic: "ٱلْجَبَّارُ",
    transliteration: "Al-Jabbar",
    meaning: "Har cheez par qaboo rakhne wala",
    reflection: "Woh toote dilon ko bhi jor deta hai.",
    benefit: "Ya Jabbar parhne se kamzori door hoti hai.",
    category: "qudrat",
  },
  {
    id: 10,
    arabic: "ٱلْمُتَكَبِّرُ",
    transliteration: "Al-Mutakabbir",
    meaning: "Buzurgi wala",
    reflection: "Asli azmat sirf Allah ke liye hai.",
    benefit: "Ya Mutakabbir parhne se takabbur se bachao hota hai.",
    category: "azmat",
  },
  {
    id: 11,
    arabic: "ٱلْخَالِقُ",
    transliteration: "Al-Khaliq",
    meaning: "Paida karne wala",
    reflection: "Har makhlooq Allah ki takhleeq hai.",
    benefit: "Ya Khaliq parhne se iman mazboot hota hai.",
    category: "khalq",
  },
  {
    id: 12,
    arabic: "ٱلْبَارِئُ",
    transliteration: "Al-Bari",
    meaning: "Nizaam se paida karne wala",
    reflection: "Allah har cheez ko hikmat ke sath paida karta hai.",
    benefit: "Ya Bari parhne se roohani tarteeb milti hai.",
    category: "khalq",
  },
  {
    id: 13,
    arabic: "ٱلْمُصَوِّرُ",
    transliteration: "Al-Musawwir",
    meaning: "Soorat dene wala",
    reflection: "Har shakal aur rang Allah ki marzi se hai.",
    benefit: "Ya Musawwir parhne se husn ki qadar hoti hai.",
    category: "khalq",
  },
  {
    id: 14,
    arabic: "ٱلْغَفَّارُ",
    transliteration: "Al-Ghaffar",
    meaning: "Baar baar maaf karne wala",
    reflection: "Woh gunahon ko baar baar bakhsh deta hai.",
    benefit: "Ya Ghaffar parhne se maghfirat milti hai.",
    category: "rehmat",
  },
  {
    id: 15,
    arabic: "ٱلْقَهَّارُ",
    transliteration: "Al-Qahhar",
    meaning: "Sab par ghalib",
    reflection: "Koi taqat Allah ke muqable mein nahi.",
    benefit: "Ya Qahhar parhne se dushman par ghalba milta hai.",
    category: "qudrat",
  },
  {
    id: 16,
    arabic: "ٱلْوَهَّابُ",
    transliteration: "Al-Wahhab",
    meaning: "Ata karne wala",
    reflection: "Woh bina hisaab deta hai.",
    benefit: "Ya Wahhab parhne se barkat milti hai.",
    category: "rizq",
  },
  {
    id: 17,
    arabic: "ٱلرَّزَّاقُ",
    transliteration: "Ar-Razzaq",
    meaning: "Rizq dene wala",
    reflection: "Har rizq Allah ki taraf se hai.",
    benefit: "Ya Razzaq parhne se rizq mein izafa hota hai.",
    category: "rizq",
  },
  {
    id: 18,
    arabic: "ٱلْفَتَّاحُ",
    transliteration: "Al-Fattah",
    meaning: "Raaste kholne wala",
    reflection: "Woh band darwaze khol deta hai.",
    benefit: "Ya Fattah parhne se mushkilat asaan hoti hain.",
    category: "rizq",
  },
  {
    id: 19,
    arabic: "ٱلْعَلِيمُ",
    transliteration: "Al-Aleem",
    meaning: "Sab kuch jaanne wala",
    reflection: "Koi cheez us se chhupi hui nahi.",
    benefit: "Ya Aleem parhne se ilm mein barkat hoti hai.",
    category: "ilm",
  },
  {
    id: 20,
    arabic: "ٱلْقَابِضُ",
    transliteration: "Al-Qabid",
    meaning: "Rokne wala",
    reflection: "Allah jis cheez ko chahe rok leta hai.",
    benefit: "Ya Qabid parhne se sabr paida hota hai.",
    category: "rizq",
  },
  {
    id: 21,
    arabic: "ٱلْبَاسِطُ",
    transliteration: "Al-Basit",
    meaning: "Kushadgi dene wala",
    reflection: "Allah jis cheez ko chahe phaila deta hai.",
    benefit: "Ya Basit parhne se dil aur rizq mein kushadgi hoti hai.",
    category: "rizq",
  },
  {
    id: 22,
    arabic: "ٱلْخَافِضُ",
    transliteration: "Al-Khafid",
    meaning: "Neecha karne wala",
    reflection: "Woh takabbur karne walon ko neecha dikhata hai.",
    benefit: "Ya Khafid parhne se ghuroor kam hota hai.",
    category: "adal",
  },
  {
    id: 23,
    arabic: "ٱلرَّافِعُ",
    transliteration: "Ar-Rafi",
    meaning: "Buland karne wala",
    reflection: "Allah jis ko chahe izzat aur darja deta hai.",
    benefit: "Ya Rafi parhne se darjat buland hote hain.",
    category: "adal",
  },
  {
    id: 24,
    arabic: "ٱلْمُعِزُّ",
    transliteration: "Al-Mu’izz",
    meaning: "Izzat dene wala",
    reflection: "Asli izzat Allah ke haath mein hai.",
    benefit: "Ya Mu’izz parhne se waqar aur izzat milti hai.",
    category: "adal",
  },
  {
    id: 25,
    arabic: "ٱلْمُذِلُّ",
    transliteration: "Al-Muzill",
    meaning: "Zillat dene wala",
    reflection: "Woh jis ko chahe ruswa kar sakta hai.",
    benefit: "Ya Muzill parhne se na-insafi se bachao hota hai.",
    category: "adal",
  },
  {
    id: 26,
    arabic: "ٱلسَّمِيعُ",
    transliteration: "As-Samee",
    meaning: "Sab kuch sunne wala",
    reflection: "Har dua aur har aawaz Allah sunta hai.",
    benefit: "Ya Samee parhne se dua mein yaqeen mazboot hota hai.",
    category: "ilm",
  },
  {
    id: 27,
    arabic: "ٱلْبَصِيرُ",
    transliteration: "Al-Baseer",
    meaning: "Sab kuch dekhne wala",
    reflection: "Koi amal Allah ki nazar se chhupa nahi.",
    benefit: "Ya Baseer parhne se apne aamal ki hifazat hoti hai.",
    category: "ilm",
  },
  {
    id: 28,
    arabic: "ٱلْحَكَمُ",
    transliteration: "Al-Hakam",
    meaning: "Faisla karne wala",
    reflection: "Aakhri faisla sirf Allah ka hota hai.",
    benefit: "Ya Hakam parhne se insaf ki samajh paida hoti hai.",
    category: "adal",
  },
  {
    id: 29,
    arabic: "ٱلْعَدْلُ",
    transliteration: "Al-Adl",
    meaning: "Insaf karne wala",
    reflection: "Allah har faisla bilkul insaf se karta hai.",
    benefit: "Ya Adl parhne se zindagi mein tawazun aata hai.",
    category: "adal",
  },
  {
    id: 30,
    arabic: "ٱللَّطِيفُ",
    transliteration: "Al-Lateef",
    meaning: "Narmi aur hikmat wala",
    reflection: "Woh nazuk tareen baaton ko bhi janta hai.",
    benefit: "Ya Lateef parhne se mushkil halat asaan hoti hain.",
    category: "ilm",
  },
  {
    id: 31,
    arabic: "ٱلْخَبِيرُ",
    transliteration: "Al-Khabeer",
    meaning: "Poora khabar rakhne wala",
    reflection: "Allah har zahiri aur batini baat se waqif hai.",
    benefit: "Ya Khabeer parhne se basirat paida hoti hai.",
    category: "ilm",
  },
  {
    id: 32,
    arabic: "ٱلْحَلِيمُ",
    transliteration: "Al-Haleem",
    meaning: "Bardasht karne wala",
    reflection: "Woh gunah ke bawajood jaldi saza nahi deta.",
    benefit: "Ya Haleem parhne se sabr aur narmi aati hai.",
    category: "rehmat",
  },
  {
    id: 33,
    arabic: "ٱلْعَظِيمُ",
    transliteration: "Al-Azeem",
    meaning: "Bohat azmat wala",
    reflection: "Us ki shaan aur qudrat be-had hai.",
    benefit: "Ya Azeem parhne se Allah ki buzurgi ka ehsaas hota hai.",
    category: "azmat",
  },
  {
    id: 34,
    arabic: "ٱلْغَفُورُ",
    transliteration: "Al-Ghafoor",
    meaning: "Maaf karne wala",
    reflection: "Allah sachay dil se tauba karne walon ko bakhsh deta hai.",
    benefit: "Ya Ghafoor parhne se maghfirat ki umeed barhti hai.",
    category: "rehmat",
  },
  {
    id: 35,
    arabic: "ٱلشَّكُورُ",
    transliteration: "Ash-Shakoor",
    meaning: "Qadar karne wala",
    reflection: "Allah choti nekion ko bhi qabool karta hai.",
    benefit: "Ya Shakoor parhne se shukar guzari paida hoti hai.",
    category: "rehmat",
  },
  {
    id: 36,
    arabic: "ٱلْعَلِيُّ",
    transliteration: "Al-Ali",
    meaning: "Buland martaba",
    reflection: "Allah sab se ooncha aur buland hai.",
    benefit: "Ya Ali parhne se roohani darja barhta hai.",
    category: "azmat",
  },
  {
    id: 37,
    arabic: "ٱلْكَبِيرُ",
    transliteration: "Al-Kabeer",
    meaning: "Bara aur azeem",
    reflection: "Us se bada koi nahi.",
    benefit: "Ya Kabeer parhne se dil mein Allah ki azmat baithti hai.",
    category: "azmat",
  },
  {
    id: 38,
    arabic: "ٱلْحَفِيظُ",
    transliteration: "Al-Hafeez",
    meaning: "Hifazat karne wala",
    reflection: "Woh apni makhlooq ki nigrani karta hai.",
    benefit: "Ya Hafeez parhne se mehfooz rehne ki dua qabool hoti hai.",
    category: "hifazat",
  },
  {
    id: 39,
    arabic: "ٱلْمُقِيتُ",
    transliteration: "Al-Muqeet",
    meaning: "Rizq aur quwwat dene wala",
    reflection: "Har rozi aur taqat Allah ki taraf se hai.",
    benefit: "Ya Muqeet parhne se zarooriyat poori hoti hain.",
    category: "rizq",
  },
  {
    id: 40,
    arabic: "ٱلْحَسِيبُ",
    transliteration: "Al-Hasib",
    meaning: "Hisaab lene wala",
    reflection: "Har amal ka hisaab Allah ke paas hai.",
    benefit: "Ya Hasib parhne se apne aamal ka khayal rehta hai.",
    category: "adal",
  },
  {
    id: 41,
    arabic: "ٱلْجَلِيلُ",
    transliteration: "Al-Jaleel",
    meaning: "Shan wala aur buzurg",
    reflection: "Allah ki azmat aur jalal be-misaal hai.",
    benefit: "Ya Jaleel parhne se Allah ki shan ka ehsaas barhta hai.",
    category: "azmat",
  },
  {
    id: 42,
    arabic: "ٱلْكَرِيمُ",
    transliteration: "Al-Kareem",
    meaning: "Bohat ata karne wala",
    reflection: "Woh bina hisaab dene wala hai.",
    benefit: "Ya Kareem parhne se barkat aur rehmat milti hai.",
    category: "rizq",
  },
  {
    id: 43,
    arabic: "ٱلرَّقِيبُ",
    transliteration: "Ar-Raqeeb",
    meaning: "Nigrani karne wala",
    reflection: "Har amal Allah ki nazar mein hai.",
    benefit: "Ya Raqeeb parhne se apne aamal ka ehsaas rehta hai.",
    category: "hifazat",
  },
  {
    id: 44,
    arabic: "ٱلْمُجِيبُ",
    transliteration: "Al-Mujeeb",
    meaning: "Dua qabool karne wala",
    reflection: "Woh har sachay dil ki pukar sunta hai.",
    benefit: "Ya Mujeeb parhne se dua qabool hone ki umeed barhti hai.",
    category: "rehmat",
  },
  {
    id: 45,
    arabic: "ٱلْوَاسِعُ",
    transliteration: "Al-Wasi",
    meaning: "Har cheez ko gherne wala",
    reflection: "Allah ka ilm aur rehmat har cheez ko shamil hai.",
    benefit: "Ya Wasi parhne se dil mein wasat paida hoti hai.",
    category: "azmat",
  },
  {
    id: 46,
    arabic: "ٱلْحَكِيمُ",
    transliteration: "Al-Hakeem",
    meaning: "Hikmat wala",
    reflection: "Har faisla Allah ki hikmat par mabni hai.",
    benefit: "Ya Hakeem parhne se samajh aur danai milti hai.",
    category: "ilm",
  },
  {
    id: 47,
    arabic: "ٱلْوَدُودُ",
    transliteration: "Al-Wadud",
    meaning: "Mohabbat karne wala",
    reflection: "Allah apne bandon se mohabbat karta hai.",
    benefit: "Ya Wadud parhne se rishton mein mohabbat barhti hai.",
    category: "rehmat",
  },
  {
    id: 48,
    arabic: "ٱلْمَجِيدُ",
    transliteration: "Al-Majid",
    meaning: "Buzurgi aur shan wala",
    reflection: "Us ki tareef aur izzat be-had hai.",
    benefit: "Ya Majid parhne se Allah ki tareef ka jazba barhta hai.",
    category: "azmat",
  },
  {
    id: 49,
    arabic: "ٱلْبَاعِثُ",
    transliteration: "Al-Ba’ith",
    meaning: "Dobara zinda karne wala",
    reflection: "Qayamat ke din Allah sab ko uthayega.",
    benefit: "Ya Ba’ith parhne se aakhirat ka ehsaas mazboot hota hai.",
    category: "zindagi",
  },
  {
    id: 50,
    arabic: "ٱلشَّهِيدُ",
    transliteration: "Ash-Shaheed",
    meaning: "Gawah rehne wala",
    reflection: "Har amal ka Allah gawah hai.",
    benefit: "Ya Shaheed parhne se sachai ki taraf rujhan hota hai.",
    category: "ilm",
  },
  {
    id: 51,
    arabic: "ٱلْحَقُّ",
    transliteration: "Al-Haqq",
    meaning: "Bilkul sach",
    reflection: "Asal haqeeqat sirf Allah hai.",
    benefit: "Ya Haqq parhne se dil mein yaqeen paida hota hai.",
    category: "adal",
  },
  {
    id: 52,
    arabic: "ٱلْوَكِيلُ",
    transliteration: "Al-Wakeel",
    meaning: "Kaam sambhalne wala",
    reflection: "Apne mamlaat Allah par chhor dena sukoon deta hai.",
    benefit: "Ya Wakeel parhne se tawakkul mazboot hota hai.",
    category: "hifazat",
  },
  {
    id: 53,
    arabic: "ٱلْقَوِيُّ",
    transliteration: "Al-Qawi",
    meaning: "Bohat taqat wala",
    reflection: "Har quwwat ka asal zariya Allah hai.",
    benefit: "Ya Qawi parhne se himmat milti hai.",
    category: "qudrat",
  },
  {
    id: 54,
    arabic: "ٱلْمَتِينُ",
    transliteration: "Al-Mateen",
    meaning: "Mazboot aur qaim",
    reflection: "Allah ki qudrat kabhi kamzor nahi hoti.",
    benefit: "Ya Mateen parhne se istiqamat milti hai.",
    category: "qudrat",
  },
  {
    id: 55,
    arabic: "ٱلْوَلِيُّ",
    transliteration: "Al-Wali",
    meaning: "Himayat karne wala",
    reflection: "Allah mominon ka madadgar hai.",
    benefit: "Ya Wali parhne se himayat aur madad milti hai.",
    category: "hifazat",
  },
  {
    id: 56,
    arabic: "ٱلْحَمِيدُ",
    transliteration: "Al-Hameed",
    meaning: "Tareef ke laiq",
    reflection: "Har tareef Allah ke liye hai.",
    benefit: "Ya Hameed parhne se shukar guzari paida hoti hai.",
    category: "azmat",
  },
  {
    id: 57,
    arabic: "ٱلْمُحْصِي",
    transliteration: "Al-Muhsi",
    meaning: "Sab kuch ginne wala",
    reflection: "Allah har cheez ka hisaab rakhta hai.",
    benefit: "Ya Muhsi parhne se apne aamal ka ehsaas hota hai.",
    category: "ilm",
  },
  {
    id: 58,
    arabic: "ٱلْمُبْدِئُ",
    transliteration: "Al-Mubdi",
    meaning: "Shuru karne wala",
    reflection: "Har ibtida Allah ki taraf se hoti hai.",
    benefit: "Ya Mubdi parhne se naye kaam mein barkat hoti hai.",
    category: "khalq",
  },
  {
    id: 59,
    arabic: "ٱلْمُعِيدُ",
    transliteration: "Al-Mu’eed",
    meaning: "Dobara lautane wala",
    reflection: "Woh dobara paida karne par qadir hai.",
    benefit:
      "Ya Mu’eed parhne se gumshuda cheez wapas milne ki umeed hoti hai.",
    category: "zindagi",
  },
  {
    id: 60,
    arabic: "ٱلْمُحْيِي",
    transliteration: "Al-Muhyi",
    meaning: "Zinda karne wala",
    reflection: "Zindagi dene wala sirf Allah hai.",
    benefit: "Ya Muhyi parhne se roohani zindagi taaza hoti hai.",
    category: "zindagi",
  },
  {
    id: 61,
    arabic: "ٱلْمُمِيتُ",
    transliteration: "Al-Mumeet",
    meaning: "Maut dene wala",
    reflection: "Zindagi aur maut dono Allah ke ikhtiyar mein hain.",
    benefit: "Ya Mumeet parhne se aakhirat ki tayyari ka ehsaas hota hai.",
    category: "zindagi",
  },
  {
    id: 62,
    arabic: "ٱلْحَيُّ",
    transliteration: "Al-Hayy",
    meaning: "Hamesha zinda",
    reflection: "Allah ko kabhi maut nahi aati.",
    benefit: "Ya Hayy parhne se roohani quwwat milti hai.",
    category: "zindagi",
  },
  {
    id: 63,
    arabic: "ٱلْقَيُّومُ",
    transliteration: "Al-Qayyum",
    meaning: "Sab ko qaim rakhne wala",
    reflection: "Kainat ka nizaam usi ke sahare chal raha hai.",
    benefit: "Ya Qayyum parhne se zindagi mein istiqamat aati hai.",
    category: "zindagi",
  },
  {
    id: 64,
    arabic: "ٱلْوَاجِدُ",
    transliteration: "Al-Wajid",
    meaning: "Har cheez paane wala",
    reflection: "Allah ko kisi cheez ki kami nahi.",
    benefit: "Ya Wajid parhne se dil ki kamiyaan door hoti hain.",
    category: "azmat",
  },
  {
    id: 65,
    arabic: "ٱلْوَاحِدُ",
    transliteration: "Al-Wahid",
    meaning: "Wahid aur akela",
    reflection: "Ibadat ke laiq sirf Allah hai.",
    benefit: "Ya Wahid parhne se tauheed mazboot hoti hai.",
    category: "azmat",
  },
  {
    id: 66,
    arabic: "ٱلْأَحَدُ",
    transliteration: "Al-Ahad",
    meaning: "Bilkul ek",
    reflection: "Allah ka koi shareek nahi.",
    benefit: "Ya Ahad parhne se iman mazboot hota hai.",
    category: "azmat",
  },
  {
    id: 67,
    arabic: "ٱلصَّمَدُ",
    transliteration: "As-Samad",
    meaning: "Be-niyaz",
    reflection: "Sab us par mohtaj hain aur woh kisi par mohtaj nahi.",
    benefit: "Ya Samad parhne se Allah par bharosa barhta hai.",
    category: "azmat",
  },
  {
    id: 68,
    arabic: "ٱلْقَادِرُ",
    transliteration: "Al-Qadir",
    meaning: "Har cheez par qadir",
    reflection: "Allah har kaam karne ki poori qudrat rakhta hai.",
    benefit: "Ya Qadir parhne se namumkin bhi mumkin lagta hai.",
    category: "qudrat",
  },
  {
    id: 69,
    arabic: "ٱلْمُقْتَدِرُ",
    transliteration: "Al-Muqtadir",
    meaning: "Bohat qudrat wala",
    reflection: "Us ki qudrat ka koi muqabla nahi.",
    benefit: "Ya Muqtadir parhne se himmat aur yaqeen milta hai.",
    category: "qudrat",
  },
  {
    id: 70,
    arabic: "ٱلْمُقَدِّمُ",
    transliteration: "Al-Muqaddim",
    meaning: "Aage karne wala",
    reflection: "Allah jis ko chahe aage barhata hai.",
    benefit: "Ya Muqaddim parhne se kamyabi ka rasta asaan hota hai.",
    category: "adal",
  },
  {
    id: 71,
    arabic: "ٱلْمُؤَخِّرُ",
    transliteration: "Al-Mu’akhkhir",
    meaning: "Peechay karne wala",
    reflection: "Woh jis cheez ko chahe dair se ata karta hai.",
    benefit: "Ya Mu’akhkhir parhne se sabr paida hota hai.",
    category: "adal",
  },
  {
    id: 72,
    arabic: "ٱلْأَوَّلُ",
    transliteration: "Al-Awwal",
    meaning: "Sab se pehle",
    reflection: "Har cheez se pehle Allah tha.",
    benefit: "Ya Awwal parhne se Allah ki azmat ka ehsaas hota hai.",
    category: "azmat",
  },
  {
    id: 73,
    arabic: "ٱلْآخِرُ",
    transliteration: "Al-Akhir",
    meaning: "Sab se aakhir",
    reflection: "Har cheez khatam ho jayegi, Allah baqi rahega.",
    benefit: "Ya Akhir parhne se duniya ki haqeeqat samajh aati hai.",
    category: "azmat",
  },
  {
    id: 74,
    arabic: "ٱلظَّاهِرُ",
    transliteration: "Az-Zahir",
    meaning: "Zahir aur numayan",
    reflection: "Allah ki qudrat har jagah nazar aati hai.",
    benefit: "Ya Zahir parhne se iman mazboot hota hai.",
    category: "ilm",
  },
  {
    id: 75,
    arabic: "ٱلْبَاطِنُ",
    transliteration: "Al-Batin",
    meaning: "Posheeda",
    reflection: "Woh zahiri aur batini dono cheezon ko janta hai.",
    benefit: "Ya Batin parhne se basirat paida hoti hai.",
    category: "ilm",
  },
  {
    id: 76,
    arabic: "ٱلْوَالِي",
    transliteration: "Al-Waliyy",
    meaning: "Nigran aur hakoomat wala",
    reflection: "Har nizaam Allah ke ikhtiyar mein hai.",
    benefit: "Ya Waliyy parhne se himayat milti hai.",
    category: "qudrat",
  },
  {
    id: 77,
    arabic: "ٱلْمُتَعَالِي",
    transliteration: "Al-Muta’ali",
    meaning: "Bohat buland",
    reflection: "Allah har kami se bohat ooncha hai.",
    benefit: "Ya Muta’ali parhne se Allah ki azmat ka ehsaas barhta hai.",
    category: "azmat",
  },
  {
    id: 78,
    arabic: "ٱلْبَرُّ",
    transliteration: "Al-Barr",
    meaning: "Bohat nek",
    reflection: "Allah apne bandon par meherban hai.",
    benefit: "Ya Barr parhne se rehmat aur barkat milti hai.",
    category: "rehmat",
  },
  {
    id: 79,
    arabic: "ٱلتَّوَّابُ",
    transliteration: "At-Tawwab",
    meaning: "Tauba qabool karne wala",
    reflection: "Woh sachay dil ki tauba qabool karta hai.",
    benefit: "Ya Tawwab parhne se gunah maaf hote hain.",
    category: "rehmat",
  },
  {
    id: 80,
    arabic: "ٱلْمُنْتَقِمُ",
    transliteration: "Al-Muntaqim",
    meaning: "Badla lene wala",
    reflection: "Allah zalimon se insaf karta hai.",
    benefit: "Ya Muntaqim parhne se zulm se bachao hota hai.",
    category: "adal",
  },
  {
    id: 81,
    arabic: "ٱلْعَفُوُّ",
    transliteration: "Al-Afuw",
    meaning: "Maaf kar dene wala",
    reflection: "Allah gunahon ko mita deta hai.",
    benefit: "Ya Afuw parhne se gunah maaf hone ki umeed barhti hai.",
    category: "rehmat",
  },
  {
    id: 82,
    arabic: "ٱلرَّؤُوفُ",
    transliteration: "Ar-Ra’uf",
    meaning: "Bohat narmi karne wala",
    reflection: "Woh apne bandon par shafqat farmata hai.",
    benefit: "Ya Ra’uf parhne se dil mein narmi paida hoti hai.",
    category: "rehmat",
  },
  {
    id: 83,
    arabic: "مَالِكُ ٱلْمُلْكِ",
    transliteration: "Malik-ul-Mulk",
    meaning: "Saltanat ka malik",
    reflection: "Har hukumat aur ikhtiyar Allah ka hai.",
    benefit: "Ya Malik-ul-Mulk parhne se izzat aur qudrat milti hai.",
    category: "qudrat",
  },
  {
    id: 84,
    arabic: "ذُو ٱلْجَلَالِ وَٱلْإِكْرَامِ",
    transliteration: "Dhul-Jalali wal-Ikram",
    meaning: "Jalal aur karam wala",
    reflection: "Allah azmat aur karam dono ka malik hai.",
    benefit: "Ya Dhul-Jalali wal-Ikram parhne se barkat milti hai.",
    category: "azmat",
  },
  {
    id: 85,
    arabic: "ٱلْمُقْسِطُ",
    transliteration: "Al-Muqsit",
    meaning: "Insaf se faisla karne wala",
    reflection: "Allah har faisla poore insaf se karta hai.",
    benefit: "Ya Muqsit parhne se insaf ki soch paida hoti hai.",
    category: "adal",
  },
  {
    id: 86,
    arabic: "ٱلْجَامِعُ",
    transliteration: "Al-Jami",
    meaning: "Ikatha karne wala",
    reflection: "Qayamat ke din sab ko jama karega.",
    benefit: "Ya Jami parhne se bikhray mamlaat judte hain.",
    category: "zindagi",
  },
  {
    id: 87,
    arabic: "ٱلْغَنِيُّ",
    transliteration: "Al-Ghani",
    meaning: "Be-niyaz aur ghani",
    reflection: "Allah ko kisi ki zarurat nahi.",
    benefit: "Ya Ghani parhne se dil ki faqri door hoti hai.",
    category: "rizq",
  },
  {
    id: 88,
    arabic: "ٱلْمُغْنِي",
    transliteration: "Al-Mughni",
    meaning: "Ghani karne wala",
    reflection: "Woh jis ko chahe be-niyaz kar deta hai.",
    benefit: "Ya Mughni parhne se tangi door hoti hai.",
    category: "rizq",
  },
  {
    id: 89,
    arabic: "ٱلْمَانِعُ",
    transliteration: "Al-Mani",
    meaning: "Rokne wala",
    reflection: "Allah jis cheez ko chahe rok deta hai.",
    benefit: "Ya Mani parhne se nuksan se bachao hota hai.",
    category: "hifazat",
  },
  {
    id: 90,
    arabic: "ٱلضَّارُ",
    transliteration: "Ad-Darr",
    meaning: "Nuksan pohanchane wala",
    reflection: "Har imtihan Allah ki taraf se hota hai.",
    benefit: "Ya Darr parhne se museebat mein sabr milta hai.",
    category: "adal",
  },
  {
    id: 91,
    arabic: "ٱلنَّافِعُ",
    transliteration: "An-Nafi",
    meaning: "Faida dene wala",
    reflection: "Har asal faida Allah ki taraf se hai.",
    benefit: "Ya Nafi parhne se nafaa hasil hota hai.",
    category: "rizq",
  },
  {
    id: 92,
    arabic: "ٱلنُّورُ",
    transliteration: "An-Nur",
    meaning: "Roshni dene wala",
    reflection: "Allah hidayat ki roshni deta hai.",
    benefit: "Ya Nur parhne se dil roshan hota hai.",
    category: "ilm",
  },
  {
    id: 93,
    arabic: "ٱلْهَادِي",
    transliteration: "Al-Hadi",
    meaning: "Raasta dikhane wala",
    reflection: "Hidayat Allah ke haath mein hai.",
    benefit: "Ya Hadi parhne se seedha raasta milta hai.",
    category: "ilm",
  },
  {
    id: 94,
    arabic: "ٱلْبَدِيعُ",
    transliteration: "Al-Badi",
    meaning: "Be-misaal paida karne wala",
    reflection: "Allah ki takhleeq be-misaal hai.",
    benefit: "Ya Badi parhne se soch mein naya pan aata hai.",
    category: "khalq",
  },
  {
    id: 95,
    arabic: "ٱلْبَاقِي",
    transliteration: "Al-Baqi",
    meaning: "Hamesha baqi rehne wala",
    reflection: "Har cheez fana ho jayegi, Allah baqi rahega.",
    benefit: "Ya Baqi parhne se duniya ki haqeeqat samajh aati hai.",
    category: "azmat",
  },
  {
    id: 96,
    arabic: "ٱلْوَارِثُ",
    transliteration: "Al-Warith",
    meaning: "Sab ka waris",
    reflection: "Aakhir mein sab kuch Allah ka reh jayega.",
    benefit: "Ya Warith parhne se dil duniya se halka hota hai.",
    category: "azmat",
  },
  {
    id: 97,
    arabic: "ٱلرَّشِيدُ",
    transliteration: "Ar-Rashid",
    meaning: "Seedha raasta dikhane wala",
    reflection: "Allah behtareen rehnumai karta hai.",
    benefit: "Ya Rashid parhne se faislon mein danai milti hai.",
    category: "ilm",
  },
  {
    id: 98,
    arabic: "ٱلصَّبُورُ",
    transliteration: "As-Saboor",
    meaning: "Bohat sabr karne wala",
    reflection: "Allah jaldi saza nahi deta.",
    benefit: "Ya Saboor parhne se sabr paida hota hai.",
    category: "rehmat",
  },
  {
    id: 99,
    arabic: "ٱلْمَالِكُ",
    transliteration: "Al-Malik (Aakhirat ka Malik)",
    meaning: "Roz-e-jaza ka malik",
    reflection: "Aakhirat mein poora ikhtiyar Allah ka hoga.",
    benefit: "Ya Malik parhne se aakhirat ki fikr paida hoti hai.",
    category: "qudrat",
  },
];
